import Phaser from "phaser";
import { type Ghost, ghostPosition, HIDES } from "../../sim";
import { type Fit, imageToScreen } from "../layout";
import { GHOST_GLOW } from "../palette";
import { GHOST_TEX_SIZE, GLOW_SIZE, TEX } from "./textures";

/** Layers: the ghost between the sky and the picture, so the set really hides it. */
export const DEPTH_SKY = -4;
export const DEPTH_STARS = -3;
const DEPTH_GHOST = -2;
export const DEPTH_BACKDROP = -1;

/** How much it bobs while out, in picture pixels, and how fast. */
const BOB = 3;
const BOB_SPEED = 0.004;

/** A friendly ghost leaning out from behind the picture and back. */
export class GhostView {
	private readonly glow: Phaser.GameObjects.Image;
	private readonly body: Phaser.GameObjects.Image;

	constructor(
		scene: Phaser.Scene,
		readonly ghost: Ghost,
	) {
		this.glow = scene.add
			.image(0, 0, TEX.glow)
			.setBlendMode(Phaser.BlendModes.ADD)
			.setTint(GHOST_GLOW)
			.setDepth(DEPTH_GHOST);
		this.body = scene.add
			.image(0, 0, TEX.ghost)
			.setAngle(HIDES[ghost.hide]?.tilt ?? 0)
			.setDepth(DEPTH_GHOST);
	}

	/** `tick` = the sim tick plus the loop's progress; `time` = ms for the bobbing. */
	update(fit: Fit, tick: number, time: number): void {
		const at = ghostPosition(this.ghost, tick);
		const r = HIDES[this.ghost.hide]?.r ?? 0;
		const p = imageToScreen(fit, at.x, at.y + BOB * at.peek * Math.sin(time * BOB_SPEED));
		this.body.setPosition(p.x, p.y).setScale((r * 2 * fit.scale) / GHOST_TEX_SIZE);
		this.glow
			.setPosition(p.x, p.y)
			.setScale((r * 3 * fit.scale) / GLOW_SIZE)
			.setAlpha(0.4 * at.peek);
	}

	destroy(): void {
		this.glow.destroy();
		this.body.destroy();
	}
}
